import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Contact.css";

const Contact = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 여기에 이메일 전송 로직 추가
    console.log("Form submitted:", formData);
    setSubmitted(true);

    // 폼 초기화
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });

    // 3초 후 submitted 상태 리셋
    setTimeout(() => {
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="contact-page">
      <div className="logo" onClick={() => navigate("/")}>
        RedoToeic
      </div>

      <div className="contact-content">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>We're here to help! Send us your questions or concerns.</p>
        </div>

        <div className="contact-container">
          <div className="contact-info">
            <div className="info-item">
              <h3>Email</h3>
              <p>support@redotoeic.com</p>
            </div>
            <div className="info-item">
              <h3>Response Time</h3>
              <p>Within 24 hours</p>
            </div>
            <div className="info-item">
              <h3>Office Hours</h3>
              <p>Monday - Friday</p>
              <p>9:00 AM - 6:00 PM KST</p>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              Send Message
            </button>

            {submitted && (
              <div className="success-message">
                Your message has been sent successfully!
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
